import React from "react";
import "./index.scss";
import { StudentSidebar } from "../../components/StudentSidebar";

interface Props {
	children: React.ReactNode;
}

const StudentGridLayout: React.FC<Props> = ({ children }) => {
	return (
		<div className="studentGridLayout grid">
			<StudentSidebar />
			<div className="main" id="mainContentInGrid">{children}</div>
		</div>
	);
};

export default StudentGridLayout;
